"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStrongestPeak = void 0;
const d3_1 = require("d3");
const getActiveSpectrum_1 = require("./getActiveSpectrum");
function getStrongestPeak(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const activeData = draft.data[activeSpectrum?.index].data;
        const strongestPeakValue = (0, d3_1.max)(activeData.re);
        const index = activeData.re.indexOf(strongestPeakValue);
        return {
            xValue: activeData.x[index],
            yValue: strongestPeakValue,
            index,
        };
    }
}
exports.getStrongestPeak = getStrongestPeak;
